import React from "react";
import { Link } from "react-router-dom";

const products = [
	{
		name: "Shady Lane Curtains",
		path: "/products/shady-lane",
		icon: "fa-border-all",
		description:
			"Premium quality dairy barn drop curtains and hardware engineered for seasonal Wisconsin climates.",
		span: "lg:col-span-3",
	},
	{
		name: "Secco Chimneys",
		path: "/products/secco-chimneys",
		icon: "fa-industry",
		description:
			"Top-performance exhaust ventilation chimneys designed to extract moist air and maintain balanced pressure.",
		span: "lg:col-span-3",
	},
	{
		name: "Fans",
		path: "/products/Fans",
		icon: "fa-wind",
		description:
			"High-capacity circulation and exhaust agricultural fans designed for peak CFM and energy efficiency.",
		span: "lg:col-span-2",
	},
	{
		name: "Freestalls",
		path: "/products/Freestalls",
		icon: "fa-grip",
		description:
			"Livestock friendly structural stalls focused on maximizing cow lying time and preventing injuries.",
		span: "lg:col-span-2",
	},
	{
		name: "EXL Lockups",
		path: "/products/EXL%20Lockups",
		icon: "fa-lock",
		description:
			"Heavy duty structural barn locks, triggers, and control hardware built with rust-resistant alloy.",
		span: "lg:col-span-2",
	},
	{
		name: "Stainless Steel Tip Tanks",
		path: "/products/Stainless%20Steel%20Tip%20Tanks",
		icon: "fa-droplet",
		description:
			"Quick-dump clean sanitation watering tanks with effortless manual or automated tipping mechanism.",
		span: "lg:col-span-3",
	},
	{
		name: "Auto Vent Controllers",
		path: "/products/Auto%20Vent%20Controllers",
		icon: "fa-sliders",
		description:
			"Smart environmental controllers that automatically adjust curtains and fans based on ambient temperature.",
		span: "lg:col-span-3",
	},
];

function Products() {
	return (
		<div className="grid grid-cols-1 gap-4 sm:gap-5 md:grid-cols-2 lg:grid-cols-6">
			{products.map((product) => (
				<Link
					key={product.name}
					to={product.path}
					className={`group flex items-start gap-3.5 rounded-2xl border border-gray-100 bg-white p-4 shadow-[0_8px_30px_rgba(15,23,42,0.06)] transition hover:-translate-y-0.5 hover:shadow-[0_12px_32px_rgba(22,69,255,0.12)] sm:gap-4 sm:p-5 md:p-6 ${product.span}`}
				>
					<div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-primary/25 bg-[#EEF3FF] text-primary sm:h-12 sm:w-12">
						<i
							className={`fa-solid ${product.icon} text-base sm:text-lg`}
							aria-hidden="true"
						></i>
					</div>
					<div className="min-w-0 text-left">
						<h2 className="font-inter text-[15px] font-bold leading-snug text-[#0f172a] sm:text-base md:text-lg">
							{product.name}
						</h2>
						<p className="mt-1.5 text-[13px] leading-relaxed text-slate-500 sm:text-sm">
							{product.description}
						</p>
					</div>
				</Link>
			))}
		</div>
	);
}

export default Products;
